import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroupExt } from '../../../../form-ext/form-group.ext';
import { AbstractControl, Validators } from '@angular/forms';
import { FormBuilderExt } from '../../../../form-ext/form-builder.ext';
import { AuthService } from '../../services/auth.service';
import { ConfigService } from '../../../../services/config/config.service';
import { HttpClient } from '@angular/common/http';
import { CompaniesService } from '../../../companies/services/companies.service';
import { UserReadableError } from '../../../../api/errors/user-readable.error';

@Component({
    selector: 'app-discovery-sso',
    templateUrl: './discovery.component.html',
    styleUrls: ['./discovery.component.scss'],
    standalone: false,
})
export class DiscoveryComponent implements OnInit, OnDestroy {
    public formGroup: FormGroupExt;
    public isLoading: boolean = false;

    constructor(
        public formBuilder: FormBuilderExt,
        public authService: AuthService,
        public companiesService: CompaniesService,
        public configService: ConfigService,
        protected readonly http: HttpClient,
    ) {}

    public get EmailControl(): AbstractControl | null {
        return this.formGroup?.group.get('email');
    }

    ngOnInit(): void {
        this.formGroup = this.formBuilder.groupExt(
            {
                email: ['', [Validators.required, Validators.email]],
            },
            {},
            {
                email: {
                    required: $localize`Email is required`,
                    email: $localize`Please enter a valid email address`,
                },
            },
        );

        window.addEventListener('pageshow', this.onPageShow.bind(this));
    }

    ngOnDestroy() {
        window.removeEventListener('pageshow', this.onPageShow.bind(this));
    }

    public async initiateDiscovery() {
        const email = this.EmailControl?.value;

        if (!email) {
            console.error('Email not valid when initiating sso discovery');
            return;
        }

        this.isLoading = true;

        this.authService.initiateMdrDiscovery(email).subscribe({
            next: ({ idpRegion }) => {
                try {
                    this.authService.initiateSsoLogin({ idpRegion, email });
                } catch (err) {
                    console.error('Error while initiating SSO login', err);
                    this.isLoading = false;
                }
            },
            error: (error: UserReadableError) => {
                this.isLoading = false;
                error.setBackendErrorsInForm(this.formGroup);
            },
        });
    }

    public async logInWithGravityZone() {
        const email = this.EmailControl?.value;

        if (!email) {
            console.error('Email not valid when initiating GravityZone IdP login');
            return;
        }

        this.isLoading = true;

        this.authService.getGravityZoneIdpRegion(email).subscribe({
            next: ({ idpRegion }) => {
                try {
                    this.authService.initiateSsoLogin({ idpRegion, email });
                } catch (err) {
                    console.error('Error while initiating GravityZone IdP login', err);
                    this.isLoading = false;
                }
            },
            error: (error: UserReadableError) => {
                this.isLoading = false;
                error.setBackendErrorsInForm(this.formGroup);
            },
        });
    }

    private onPageShow(event: PageTransitionEvent): void {
        if (!event.persisted) {
            return;
        }

        // The page was restored from bfcache (e.g., user navigated back from another site)
        this.isLoading = false;
    }
}
